package one.healthium.log_food.ui.scan_results.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.dp
import loco.LOG_FOOD_AMOUNT_FIELD_LABEL
import loco.LOG_FOOD_FOOD_DETAILS_CARBS_LABEL
import loco.LOG_FOOD_FOOD_DETAILS_FAT_LABEL
import loco.LOG_FOOD_FOOD_DETAILS_FIBER_LABEL
import loco.LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL
import one.healthium.base.utils.Formatters.formatCalories
import one.healthium.base.utils.Formatters.formatGrams
import one.healthium.loco.resolve
import one.healthium.log_food.ui.scan_results.ScanResultFoodItem
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black10
import one.healthium.ui.compose.theme.gray_13
import one.healthium.ui.compose.theme.gray_3
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

internal val CardShape = RoundedCornerShape(12.dp)

@Composable
internal fun ScanResultFoodItemCard(
    modifier: Modifier = Modifier,
    item: ScanResultFoodItem,
    onAmountClicked: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .clip(CardShape)
            .background(gray_13, CardShape)
            .padding(horizontal = 12.dp),
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 12.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.Top,
        ) {
            Text(
                modifier = Modifier.weight(1f),
                text = item.food.displayName,
                style = AppTheme.textStyles.secondary_18_700,
                color = AppTheme.colors.text100,
                maxLines = 2,
            )
            Text(
                modifier = Modifier.padding(start = 8.dp),
                text = item.calories.formatCalories().resolve(),
                style = AppTheme.textStyles.secondary_18_700,
                color = AppTheme.colors.text100,
                textAlign = TextAlign.End,
            )
        }

        Text(
            text = buildFoodNutrientAnnotatedText(
                carbs = item.carbohydrates,
                fat = item.fat,
                protein = item.protein,
                fiber = item.fiber,
            ),
            style = AppTheme.textStyles.secondary_18_400,
            color = AppTheme.colors.text100,
        )

        Spacer(Modifier.height(12.dp))

        HorizontalDivider(
            thickness = 1.dp,
            color = black10,
        )

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clickable(onClick = onAmountClicked)
                .padding(vertical = 12.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Text(
                text = stringResource(loco.Res.string.LOG_FOOD_AMOUNT_FIELD_LABEL),
                style = AppTheme.textStyles.secondary_16_500,
                color = AppTheme.colors.text100,
            )
            Text(
                modifier = Modifier.weight(1f),
                text = item.amount.displayValue.resolve(),
                style = AppTheme.textStyles.secondary_16_500,
                color = gray_3,
                textAlign = TextAlign.End,
            )
            Spacer(Modifier.width(8.dp))
            Image(
                modifier = Modifier.size(width = 8.dp, height = 13.dp),
                painter = painterResource(AppIcons.icArrowRight),
                contentDescription = null,
            )
        }
    }
}

@Composable
internal fun buildFoodNutrientAnnotatedText(
    carbs: Float,
    fat: Float,
    protein: Float,
    fiber: Float,
): AnnotatedString {
    val carbsLabel = stringResource(loco.Res.string.LOG_FOOD_FOOD_DETAILS_CARBS_LABEL)
    val fatLabel = stringResource(loco.Res.string.LOG_FOOD_FOOD_DETAILS_FAT_LABEL)
    val proteinLabel = stringResource(loco.Res.string.LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL)
    val fiberLabel = stringResource(loco.Res.string.LOG_FOOD_FOOD_DETAILS_FIBER_LABEL)
    val boldStyle = SpanStyle(fontWeight = AppTheme.textStyles.secondary_18_700.fontWeight)
    return buildAnnotatedString {
        withStyle(boldStyle) { append(carbsLabel) }
        append(" ${carbs.formatGrams().resolve()}, ")
        withStyle(boldStyle) { append(fatLabel) }
        append(" ${fat.formatGrams().resolve()}, ")
        withStyle(boldStyle) { append(proteinLabel) }
        append(" ${protein.formatGrams().resolve()}, ")
        withStyle(boldStyle) { append(fiberLabel) }
        append(" ${fiber.formatGrams().resolve()}")
    }
}
